import { useState, useEffect } from 'react';
import { fetchSettings } from '../api/settings';

const DEFAULT = {
  contactNumber:  '+91 9638853253',
  whatsappNumber: '+91 9638853253',
  email:          'support@sadguruflower.com',
  website:        'https://sadguruflower.com',
  version:        null,
};

export function useSettings() {
  const [settings, setSettings] = useState(DEFAULT);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    fetchSettings()
      .then(data => setSettings({ ...DEFAULT, ...data }))
      .catch(err  => setError(err))
      .finally(()  => setLoading(false));
  }, []);

  return { settings, loading, error };
}
